import { r as e, h as a } from "./index-f8317a8e.js";
import "react";
import "react-dom";
const i = ".wave{display:flex;align-items:center;justify-content:center}.dot{width:4px;height:4px;background-color:var(--dot-color, white);border-radius:50%;margin:0 2px;animation:wave 1.5s infinite ease-in-out}.dot:nth-child(2){animation-delay:0.2s}.dot:nth-child(3){animation-delay:0.4s}@keyframes wave{0%,60%,100%{transform:translateY(0)}30%{transform:translateY(-4px)}}", n = i, o = class {
  constructor(t) {
    e(this, t), this.width = "15", this.height = "15";
  }
  render() {
    return a("div", { key: "a4e02600769a3b45a4bb61ec0675b4a1ddf50e02", class: "wave" }, a("div", { key: "f780d1ab48209ae02ee1e9106283c8a2ac8c71ca", class: "dot" }), a("div", { key: "35e78602850b5110303781dfa1d754d0763dfd44", class: "dot" }), a("div", { key: "4553229aa0729c110f65b6a27a1566630415bf88", class: "dot" }));
  }
};
o.style = n;
export {
  o as loading_icon
};
